import Vue from "vue"
import {updateField} from "vuex-map-fields"
import {getField} from "vuex-map-fields"

export const actions = {
    openPanel({state}, edit_data={}) {
        if (state.panel_open) return Vue.noty.error('Close is already open. Please close it to open a new one.')
        state.panel_open = true
        state.edit_data = edit_data;
    },
    closePanel({state}) {
        state.panel_open = false;
        state.edit_data = {};
    },
}

export const getters = {
    getField,
}

export const mutations = {
    updateField,
}

export const state = () => ({
   panel_open: false,
   edit_data: {}
})
